const isSettlementZero = ({ ouncesPt, ouncesPd, ouncesRh }) =>
  ouncesPt === 0 && ouncesPd === 0 && ouncesRh === 0;

export { isSettlementZero };
